import React, { PureComponent } from 'react';
import { Edit as EditIcon, Delete as TrashIcon } from '@mui/icons-material';
import { helpers } from '@simplybenefits/sb-utils';
import * as dates from '@simplybenefits/sb-dates';
import { colors } from '../../theme/index.js';
import Text from '../../components/Text.js';
import Button from '../../components/Button.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class EntityTable extends PureComponent {
  render() {
    const {
      items
    } = this.props;
    const styles = {
      block: {
        backgroundColor: colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        height: 'auto'
      },
      header: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'center',
        padding: '10px 30px 10px 30px'
      },
      row: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'center',
        paddingTop: 10,
        paddingBottom: 10,
        borderTop: "1px solid #eee",
        padding: '10px 30px 10px 30px'
      },
      title: {
        width: '25%'
      },
      description: {
        width: '35%'
      },
      effDate: {
        width: '20%'
      },
      actions: {
        display: "flex",
        alignItems: "flex-end",
        flexDirection: "row",
        justifyContent: "flex-end",
        width: '20%'
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      style: styles.block
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.header
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.title
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.classesAndDivisions.name))), /*#__PURE__*/React.createElement("div", {
      style: styles.description
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.classesAndDivisions.description))), /*#__PURE__*/React.createElement("div", {
      style: styles.description
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, i18n.t(tokens.labels.effectiveDate)))), helpers.sortObjByTitle(items).map(id => {
      const item = items[id];

      // if it's modular flex we only want to show the parent class
      if (item.isModular && item.parentClassID !== null) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.row,
        key: id
      }, /*#__PURE__*/React.createElement("div", {
        style: styles.title
      }, /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true
      }, item.title)), /*#__PURE__*/React.createElement("div", {
        style: styles.description
      }, /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true
      }, item.description)), item.classEffectiveDate ?
      /*#__PURE__*/
      // this displays the class and division Effective dates only if the account is not pending - there are tripled up ternaries because it handles revision data, quote data, pending data and live data
      React.createElement("div", {
        style: styles.effDate
      }, item.status === undefined && item.isNew === undefined ? /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true,
        customStyle: {
          paddingLeft: "40px"
        }
      }, "-") : /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true
      }, dates.getStartOfDay(item.classEffectiveDate, "ll"))) : item.eligibilityOverrideDate ? /*#__PURE__*/React.createElement("div", {
        style: styles.effDate
      }, /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true
      }, dates.getStartOfDay(item.eligibilityOverrideDate, "ll"))) : /*#__PURE__*/React.createElement("div", {
        style: styles.effDate
      }, item.status === undefined && item.isNew === undefined ? /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true,
        customStyle: {
          paddingLeft: "40px"
        }
      }, "-") : /*#__PURE__*/React.createElement(Text, {
        medium: true,
        light: true
      }, dates.getStartOfDay(item.accountEffectiveDate, "ll"))), /*#__PURE__*/React.createElement("div", {
        style: styles.actions
      }, this.props.edit && /*#__PURE__*/React.createElement(Button, {
        onClick: () => this.props.edit(item),
        transparent: true
      }, /*#__PURE__*/React.createElement(EditIcon, {
        style: {
          fontSize: 17,
          lineHeight: '14px',
          color: 'inherit'
        }
      })), this.props.remove && /*#__PURE__*/React.createElement(Button, {
        onClick: () => this.props.remove(item),
        transparent: true
      }, /*#__PURE__*/React.createElement(TrashIcon, {
        style: {
          fontSize: 17,
          lineHeight: '14px',
          color: 'inherit'
        }
      }))));
    }));
  }
}
export default EntityTable;